import React, { useMemo, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SummaryWrapper } from '../../../components/SummaryWrapper/';
import './dashboard.scss';
import { Button, Dropdown } from 'antd';
import { UploadOutlined, DownOutlined } from '@ant-design/icons';
import { DISCOVERY_ROUTE_CONFIG } from '../../../constants/routes';

export const DiscoveryDashboard = () => {
    const navigate = useNavigate();
    const [dashboardHasNoData, setDashboardHasNoData] = useState(false); // Controlled by SummaryWrapper
    const importButtonDropdown = useMemo(
        () => [{ key: '1', label: 'RVTools', onClick: () => navigate(DISCOVERY_ROUTE_CONFIG.rvTools.path) }],
        [navigate],
    );

    return (
        <div className="discovery-dashboard">
            <SummaryWrapper
                setDashboardHasNoData={setDashboardHasNoData}
                canRenderImportButton={true}
                title="Discovery"
                showCardEllipsis={false}
                showMarkReadyInfo={false}
                showViewModeToggle={false}
                collapsible
            />
            {dashboardHasNoData && (
                <Dropdown menu={{ items: importButtonDropdown }} placement="bottomRight" arrow>
                    <Button shape="round" type="primary" icon={<UploadOutlined />} className="import-button">
                        Import <DownOutlined />
                    </Button>
                </Dropdown>
            )}
        </div>
    );
};
